<template>
  <div class="saas_good_list home_page">
    <!--  home_page -->
    <el-row :gutter="20">
      <el-col :span="6"
              v-for="(item, index) in goodList"
              :key="item.spuId">
        <div @mouseover="changeHandle(index, true)"
             @mouseout="changeHandle(index, false)"
             class="good_item">
          <div class="good_img" @click="goodDetail(item)">
            <img :src="item|getImg" alt="" width="100%" height="160px">
            <div class="good_name">{{item.name}}</div>
          </div>
          <div class="multi_line_overflow good_des line-break" v-show="!item.showOpt">
            {{item.a}}
          </div>
          <div class="good_opt" v-show="item.showOpt">
            <div class="good_detail" @click="goodDetail(item)">了解详情</div>
            <div class="good_apply flex-grow" @click="applyHandle(item)">立即咨询</div>
          </div>
        </div>
      </el-col>
    </el-row>
    <div class="home_page" v-show="goodList.length === 0">
      <div class="no_show_message">
        <img src="@/assets/img/good/noGood.png"
             alt="暂无商品">
        <div>暂无商品</div>
      </div>
    </div>
  </div>
</template>
<script>
import { openOther } from '@/utils'
export default {
  data () {
    return {
      goodList: [],
      total: 0,
      page: 1
      // defaultImg: require('@/assets/img/zwtp.png')
    }
  },
  filters: {
    getImg (spu) {
      let img = require('@/assets/img/zwtp.png') // this.defaultImg
      if (spu.pictureUrlList && spu.pictureUrlList.length) {
        img = spu.pictureUrlList[0]
      }
      return img
    }
  },
  mounted () {
    this.getDataList(1)
  },
  methods: {
    changeHandle (index, flag) {
      this.goodList[index].showOpt = flag
      this.$set(this.goodList, index, this.goodList[index])
    },
    getDataList (page = this.page) {
      this.page = page
      this.$http.post(`/front/cross/commodity-user/web/saas/spu-list`, {
        resourceCode: this.$route.query.code || 'SZJLZ' // SZJLZ(云应用)、SRDMS(rdms商品)
      })
        .then(({ data: res }) => {
          if (res.code !== 0) {
            this.goodList = []
            this.total = 0
            return false
          }
          this.goodList = res.data.dataList || []
          this.total = res.count
        })
        .catch(() => {
          this.goodList = []
          this.total = 0
        })
    },
    goodDetail (good) {
      if (good && good.spuId) {
        openOther(`goodDetail?spuId=${good.spuId}&skuId=`)
      }
    },
    applyHandle (good) {
      this.$router.push({
        name: 'applyUsed'
      })
    }
  }
}
</script>
<style lang='scss' scoped>
.saas_good_list{
  padding: 10px;
  background-color: #fff;
  .good_item{
    padding: 5px;
    height: 280px;
    .good_img{
      position: relative;
      cursor: pointer;
      .good_name{
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 30px;
        line-height: 30px;
        text-align: center;
        background: #000;
        opacity: 0.5;
        color: #fff;
      }
    }
  }
  .good_opt{
    display: flex;
    margin-top: 10px;
    line-height: 36px;
    border: 1px solid #1a5b97;
    cursor: pointer;
    .good_detail{
      color: #1a5b97;
      width: 49%;
      text-align: center;
    }
    .good_apply{
      background-color: #1a5b97;
      color: #fff;
      text-align: center;
    }
  }
  .good_des{
    margin-top: 10px;
    -webkit-line-clamp: 4;
    line-height: 18px;
    height: 72px;
  }
}
</style>
